import { useState } from 'react';

export function useNumberInput(initialValue: number, name?: string, float = false) {
  const [value, setValue] = useState(initialValue);

  return {
    value,
    setValue,
    reset: () => setValue(initialValue),
    bind: {
      value,
      name,
      onChange: (event: any) => {
        setValue(float ? parseFloat(event.target.value) : parseInt(event.target.value, 10));
      },
      setValue: (val: number) => setValue(val),
    },
  };
}

export function useFloatInput(initialValue: number | string, min: number, max: number, name?: string) {
  const [value, setValue] = useState<string | number>(initialValue);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    if (/^-?\d*\.?\d*$/.test(inputValue)) {
      if (inputValue === '' || inputValue === '-' || inputValue.endsWith('.')) {
        setValue(inputValue);
        return;
      }

      const numericValue = parseFloat(inputValue);

      if (!Number.isNaN(numericValue) && numericValue >= min && numericValue <= max) {
        setValue(numericValue);
      }
    }
  };

  return {
    value,
    setValue,
    reset: () => setValue(initialValue),
    bind: {
      name,
      value,
      onChange: handleChange,
      setValue: (val: number) => setValue(val),
    },
  };
}
